import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { useTranslation } from 'react-i18next';

interface CreateResellerPublicationPayload {
  reseller_id: number;
}

export const useCreateResellerPublication = (
  resellerId: string | undefined
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const createResellerPublication = async (
    payload: CreateResellerPublicationPayload
  ) => {
    if (!resellerId) {
      throw new Error(t('plan-id-is-not-defined'));
    }
    const response = await Axios.post(
      `${POST_URL(resellerId).publication}`,
      payload
    );
    return response.data;
  };

  return useMutation<
    void,
    AxiosError<BaseError>,
    CreateResellerPublicationPayload
  >(createResellerPublication, {
    onSuccess: () => {
      queryClient.invalidateQueries(['publication', resellerId]);
    },
    useErrorBoundary: false
    // ❌ No toasts here – handled in component via toast.promise()
  });
};
